import React from 'react';
import { Link } from 'react-router-dom';
import RecruiterLogin from './RecruiterLogin';
import LoginHeader from './LoginHeader';
import LoginFooter from './LoginFooter';
import SocialLogin from './SocialLogin';
import { Card, CardContent } from '@/Components/ui/card';
import { cn } from '@/lib/utils';

function RecruiterLoginPage() {
  return (
    <div className="min-h-screen w-full bg-background text-foreground flex flex-col justify-center items-center relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-[0.02] pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `radial-gradient(circle at 2px 2px, hsl(var(--foreground)) 1px, transparent 0)`,
          backgroundSize: '40px 40px'
        }} />
      </div>

      {/* Logo Section - Top Left */}
      <div className="absolute top-6 left-6 md:top-8 md:left-8 z-10">
        <Link 
          to="/hirewithus"
          className="transition-opacity hover:opacity-80"
        >
          <img
            src="/Newzenalphablue.png"
            alt="SearchJob.ai Logo"
            className="h-8 md:h-10 w-auto object-contain drop-shadow-sm"
          />
        </Link>
      </div>
      
      <div className="flex justify-center items-center gap-12 max-w-7xl w-full flex-wrap px-6 py-12 md:flex-nowrap relative z-10">
        <Card className={cn(
          "flex flex-col w-full max-w-[480px] p-8 md:p-10",
          "bg-card border border-border/50",
          "shadow-xl shadow-primary/5",
          "transition-all duration-300",
          "hover:shadow-2xl hover:shadow-primary/10"
        )}>
          <CardContent className="w-full p-0 space-y-6">
            <LoginHeader />
            <RecruiterLogin />
            <SocialLogin />
            <LoginFooter />
          </CardContent>
        </Card>
        
        <div className="hidden lg:block flex-shrink-0">
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-br from-primary/10 via-primary/5 to-transparent rounded-2xl blur-2xl" />
            <img 
              className="relative w-full max-w-[520px] aspect-[0.72] object-cover rounded-2xl shadow-2xl"
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/5e5cac7852424a1242a40a6c85ea3ed154da859a360e0fcb3f8eac46509d3baa?placeholderIfAbsent=true&apiKey=011132b2f41c4af7b38e22acc88aa803"
              alt="Login illustration"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecruiterLoginPage;
